import React from "react"
import { Link } from "gatsby"

class NavLinks extends React.PureComponent {
    render() {
        return (
          <>
              <li className="nav-item">
                <Link to="/">All Champs</Link>
              </li>
              <li className="nav-item">
                <Link to="/mychamps">My Champs</Link>
              </li>
              <li className="nav-item">
                <Link to="/sharemyteam">Share My Team</Link>
              </li>
              {/* <li className="nav-item">
                <Link to="/mymercy">My Mercy</Link>
              </li> */}
              <li className="nav-item">
                <Link to="/about">About</Link>
              </li>
              <li className="nav-item">
                <Link to="/contribute">Contribute</Link>
              </li>
              <li className="nav-item">
                <Link to="/contact">Contact</Link>
              </li>
              {/* <li className="nav-item">
                <Link to="/testimonials">Testimonials</Link>
              </li> */}
              {/*<Login/>*/}
          </>
        )
    }
}

export default NavLinks
